document.addEventListener('DOMContentLoaded', function() {
  // Wait for VariantSelects to be defined
  const interval = setInterval(function() {
    if (!customElements.get('variant-selects')) return;
    clearInterval(interval);

    const HIDE_VARIANTS = ['265 Gal Tote'];
    const OriginalVariantSelects = customElements.get('variant-selects');
    const originalUpdatePrice = OriginalVariantSelects.prototype.updatePrice;

    OriginalVariantSelects.prototype.updatePrice = function(responseText) {
      // Call original first
      originalUpdatePrice.call(this, responseText);
      // Then immediately hide if needed
      if (this.currentVariant && HIDE_VARIANTS.some(v => this.currentVariant.title.includes(v))) {
        const priceEls = document.querySelectorAll('[id^="Price-"], .product__price, .product__price-mobile');
        priceEls.forEach(el => el.style.setProperty('display', 'none', 'important'));
        document.querySelectorAll('.gBackInStockBtn').forEach(el => el.style.setProperty('display', 'none', 'important'));
        window.currentVariantTitle = this.currentVariant.title;
      }
    };
  }, 100);
});